import axios from 'axios'
import {CreateClientPayload} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const OAUTH_CLIENTS_API = `${API_URL}/oauth-clients`

export const service = {
  getClients: () => axios.get(OAUTH_CLIENTS_API),
  createClient: (body: CreateClientPayload) => axios.post(OAUTH_CLIENTS_API, body),
  revokeClient: (id: string) => axios.post(`${OAUTH_CLIENTS_API}/${id}/revoke`),
  deleteClient: (id: string) => axios.delete(`${OAUTH_CLIENTS_API}/${id}`),
  getTokens: (id: string) => axios.get(`${OAUTH_CLIENTS_API}/${id}/tokens`),
}
